module.exports = __webpack_public_path__ + "img/logo.7020e2dd.png";